import { graphql } from 'services/api';
import { REMOVE_PAGE } from 'graphqlQueriesAndMutations/mutations';

export async function deletePage(id: string, handleNotify: any) {
	const resp = { isSuccess: false };

	try {
		await graphql.mutate({
			mutation: REMOVE_PAGE,
			variables: { id }
		});
		handleNotify('Página deletada com sucesso', 'success');
		resp.isSuccess = true;
	} catch {
		resp.isSuccess = false;
		handleNotify('Houve algum erro para deletar a página', 'error');
	}

	return resp;
}
